export default __webpack_public_path__ + "static/media/contanciasnodeudorfirst.63a653ed.png";